var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.1504C20 15.7563 15.5228 20.3008 10 20.3008C4.47715 20.3008 0 15.7563 0 10.1504C0 4.54448 4.47715 0 10 0C15.5228 0 20 4.54448 20 10.1504Z",
    fill: "#F3636E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4884 7.69035C15.8697 7.29079 15.8549 6.6578 15.4553 6.27653C15.0558 5.89526 14.4228 5.91008 14.0415 6.30965L15.4884 7.69035ZM8.08539 14L7.36192 14.6904C7.55062 14.8881 7.81205 15 8.08539 15C8.35873 15 8.62016 14.8881 8.80886 14.6904L8.08539 14ZM5.46908 9.80965C5.0878 9.41008 4.45481 9.39526 4.05525 9.77653C3.65569 10.1578 3.64086 10.7908 4.02213 11.1904L5.46908 9.80965ZM14.0415 6.30965L7.36192 13.3096L8.80886 14.6904L15.4884 7.69035L14.0415 6.30965ZM8.80886 13.3096L5.46908 9.80965L4.02213 11.1904L7.36192 14.6904L8.80886 13.3096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickRedCircle);
export default __webpack_public_path__ + "static/media/TickRedCircle.0db16b9fb17eed0d5940f32b566b4918.svg";
export { ForwardRef as ReactComponent };